export const GRID_GUTTER_WIDTH = '10px';
export const SERVICES_ROW_MARGIN = '-5px';
